import React, { useState } from 'react';
import { SignupData } from '../../../pages/SignupPage';
import { XIcon } from 'lucide-react';
interface AgentFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const AgentForm: React.FC<AgentFormProps> = ({
  updateDetails,
  data
}) => {
  const [specializationInput, setSpecializationInput] = useState('');
  const handleAddSpecialization = () => {
    if (specializationInput.trim() !== '') {
      const currentSpecializations = data.profileDetails?.specialization || [];
      updateDetails({
        specialization: [...currentSpecializations, specializationInput.trim()]
      });
      setSpecializationInput('');
    }
  };
  const handleRemoveSpecialization = (index: number) => {
    const currentSpecializations = [...(data.profileDetails?.specialization || [])];
    currentSpecializations.splice(index, 1);
    updateDetails({
      specialization: currentSpecializations
    });
  };
  return <div className="space-y-4" data-id="element-35">
      <div data-id="element-36">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-37">
          Agency Name
        </label>
        <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. Elite Sports Management" value={data.profileDetails?.agencyName || ''} onChange={e => updateDetails({
        agencyName: e.target.value
      })} data-id="element-38" />
      </div>
      <div data-id="element-39">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-40">
          Years of Experience
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 7" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-41" />
      </div>
      <div data-id="element-42">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-43">
          Number of Clients
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 15" value={data.profileDetails?.clientCount || ''} onChange={e => updateDetails({
        clientCount: parseInt(e.target.value) || 0
      })} data-id="element-44" />
      </div>
      <div data-id="element-45">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-46">
          Areas of Specialization
        </label>
        <div className="flex" data-id="element-47">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. Contract Negotiation, Youth Talent" value={specializationInput} onChange={e => setSpecializationInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddSpecialization())} data-id="element-48" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddSpecialization} data-id="element-49">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-50">
          {(data.profileDetails?.specialization || []).map((spec, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-51">
              <span className="flex-1" data-id="element-52">{spec}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveSpecialization(index)} data-id="element-53">
                <XIcon size={16} data-id="element-54" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default AgentForm;